import jlptScoreLevel from '@/api/customer/master/jlpt-score-level'

const data = {
  items: sessionStorage.getItem('jlptScoreLevels')
    ? JSON.parse(sessionStorage.getItem('jlptScoreLevels'))
    : []
}

export default {
  namespaced: true,
  state () {
    return {
      ...data
    }
  },
  mutations: {
    /**
     * Reset the state to default.
     *
     * @param {*} state
     */
    RESET (state) {
      for (const key in state) {
        state[key] = data[key]
      }
    },

    /**
     * Set the items.
     *
     * @param {*} state
     * @param {*} items
     */
    SET_ITEMS (state, items) {
      state.items = items
    }
  },
  actions: {
    /**
     * Get all JlptScoreLevel records.
     *
     * @param {*}
     */
    all ({ commit, dispatch, state }) {
      if (state.items.length) return

      return jlptScoreLevel.index()
        .then(({ data }) => {
          commit('SET_ITEMS', data)

          sessionStorage.setItem('jlptScoreLevels', JSON.stringify(data))
        })
        .catch(({ response }) => dispatch('httpException/handle', response, { root: true }))
    }
  }
}
